import { STATION_DOWNTIME_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  stationDownTimeReport: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const stationDownTimeReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case STATION_DOWNTIME_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }
    case STATION_DOWNTIME_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        stationDownTimeReport: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case STATION_DOWNTIME_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default stationDownTimeReportReducer;
